////////LIBRARY/////////
import update from 'immutability-helper'
///////COMPONENTS///////
import extendUpdate from '../../helpers/extendUpdate'
import ActionsTypes from '../../constants/ActionsTypes'

extendUpdate(update)

const salesHistoryManager = {
	[ActionsTypes.GET_SALES_HISTORY]: (state) =>
		update(state, {
			salesHistoryManager: {
				isLoading: {
					$set: true,
				},
				items: {
					$set: [],
				},
			},
			columns: {
				isSearchfieldUpdated: {
					$set: false,
				},
				currentDir: {
					$set: '',
				},
				currentColumn: {
					$set: '',
				},
			},
		}),
	[ActionsTypes.GET_SALES_HISTORY_SUCCESS]: (state, payload) => {
		const paging = {
			totalElements: payload.data.headerContent.contentPagined.totalElements,
			totalPages: payload.data.headerContent.contentPagined.totalPages,
		}
		return update(state, {
			salesHistoryManager: {
				isLoading: {
					$set: false,
				},
				items: {
					$set: payload.data.headerContent.contentPagined.content,
				},
				paging: {
					$set: paging,
				},
				header: {
					$set: payload.data.headerParam.filters,
				},
			},
		})
	},
	[ActionsTypes.GET_SALES_HISTORY_FAILURE]: (state, payload) =>
		update(state, {
			salesHistoryManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.SEND_MERCHANT_TICKET]: (state) =>
		update(state, {
			salesHistoryManager: {
				isLoading: {
					$set: true,
				},
				error: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.SEND_MERCHANT_TICKET_SUCCESS]: (state, _payload) => {
		return update(state, {
			salesHistoryManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
			},
		})
	},
	[ActionsTypes.SEND_MERCHANT_TICKET_FAILURE]: (state, payload) =>
		update(state, {
			salesHistoryManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.SEND_GUEST_TICKET]: (state) =>
		update(state, {
			salesHistoryManager: {
				isLoading: {
					$set: true,
				},
				error: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.SEND_GUEST_TICKET_SUCCESS]: (state, _payload) => {
		return update(state, {
			salesHistoryManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
			},
		})
	},
	[ActionsTypes.SEND_GUEST_TICKET_FAILURE]: (state, payload) =>
		update(state, {
			salesHistoryManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.SET_TRANSACTION_NUMBER]: (state, payload) => {
		return update(state, {
			consignation: {
				transactionNumber: {
					$set: payload.transactionNumber,
				},
			},
		})
	},
	[ActionsTypes.RESET_TRANSACTION_NUMBER_CONSIGNATION]: (state) => {
		return update(state, {
			consignation: {
				transactionNumber: {
					$set: '',
				},
			},
		})
	},
	[ActionsTypes.RESET_TRANSACTION_ITEMS]: (state, _payload) => {
		return update(state, {
			salesHistoryManager: {
				items: {
					$set: [],
				},
				transactionNumber: {
					$set: {},
				},
				header: {
					$set: {},
				},
			},
		})
	},
	[ActionsTypes.SET_TELECOLLECT_ID]: (state, payload) => {
		let paymentCollectionId = payload.telecollectId
		return update(state, {
			telecollectManager: {
				telecollectId: {
					$set: paymentCollectionId,
				},
			},
		})
	},
	[ActionsTypes.SET_PROMOTION_NUMBER]: (state, payload) => {
		let promotionNumber = payload.promotionNumber
		return update(state, {
			scheduledPromoManager: {
				promotionNumber: {
					$set: promotionNumber,
				},
			},
		})
	},
}

export default salesHistoryManager
